import React, { Component } from "react";
import { connect } from "react-redux";
import {
  retrieveEngins,
  findEnginsByTitle,
  deleteAllEngins,
} from "../actions/engins";
import { Link } from "react-router-dom";

class EnginsList extends Component {
  constructor(props) {
    super(props);
    this.onChangeSearchNom = this.onChangeSearchNom.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.setActiveEngin = this.setActiveEngin.bind(this);
    this.findByNom = this.findByNom.bind(this);
    this.removeAllEngins = this.removeAllEngins.bind(this);

    this.state = {
      currentEngin: null,
      currentIndex: -1,
      searchNom: "",
    };
  }

  componentDidMount() {
    this.props.retrieveEngins();

  }

  onChangeSearchNom(e) {
    const searchNom = e.target.value;

    this.setState({
      searchNom: searchNom,
    });
  }

  refreshData() {
    this.setState({
      currentEngin: null,
      currentIndex: -1,
    });
  }

  setActiveEngin(engin, index) {
    this.setState({
      currentEngin: engin,
      currentIndex: index,
    });
  }

  removeAllEngins() {
    this.props
      .deleteAllEngins()
      .then((response) => {
        console.log(response);
        this.refreshData();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  findByNom() {
    this.refreshData();

    this.props.findEnginsByTitle(this.state.searchNom);
  }

  render() {
    const { searchNom, currentEngin, currentIndex } = this.state;
    const {engins} = this.props;


    return (
      <div className="list row">
        <div className="col-md-8">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher un engin"
              value={searchNom}
              onChange={this.onChangeSearchNom}
            />

            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.findByNom}
              >
                Rechercher
              </button>

            </div>

          </div>
        </div>
        <div className="col-md-6">
          <h4>Liste des engins</h4>

          <ul className="list-group">

            {engins &&
            engins.map((engin, index) => (

                  <li
                  className={
                    "list-group-item " +
                    (index === currentIndex ? "active" : "")
                  }

                  onClick={() => this.setActiveEngin(engin)}
                  key={engin.id}

                >
                    <ul> {engin.Nom}
                    </ul>
                    <ul><img className="img" src={engin.Img1} alt={engin.Img1}/></ul>
                </li>


              ))}
          </ul>

          <button
            className="m-3 btn btn-sm btn-danger"
            onClick={this.removeAllEngins}
          >
            Supprimer tous les engins
          </button>
        </div>
        <div className="col-md-6">
          {currentEngin ? (
            <div>
              <h4>Engin</h4>
              <div>
                <label>
                  <strong>Nom:</strong>
                </label>{" "}
                {currentEngin.Nom}
              </div>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>{" "}
                {currentEngin.published ? "Published" : "Pending"}
              </div>

              <Link
                to={"/engins/" + currentEngin.id}
                className="badge badge-warning"
              >
                Editer
              </Link>
            </div>
          ) : (
            <div>
              <br />
              <p>Cliquez sur un engin ou  </p>
              <p>  <a className="nav-item"
                            href="https://gestion.attirail.fr/addengins" type="button"> Ajouter un engin </a>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    engins: state.engins,
  };
};

export default connect(mapStateToProps, {
  retrieveEngins,
  findEnginsByTitle,
  deleteAllEngins,
})(EnginsList);
